var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:{
    'appearance-primary': _vm.appearance === 'primary',
    'appearance-secondary': _vm.appearance === 'secondary',
    'appearance-square': _vm.appearance === 'square',
    'appearance-menu': _vm.appearance === 'menu',
    'size-large': _vm.size === 'large',
    'size-medium': _vm.size === 'medium',
    'size-small': _vm.size === 'small',
    'size-mini': _vm.size === 'mini',
    'size-square': _vm.size === 'square',
    'text-center': _vm.textAlignment === 'center',
    'text-left': _vm.textAlignment === 'left',
    'text-right': _vm.textAlignment === 'right'
  },attrs:{"type":_vm.type,"disabled":!_vm.isDisabled,"aria-label":_vm.ariaLabel,"id":_vm.id},on:{"click":function($event){return _vm.$emit('click', _vm.action)}}},[(_vm.prefix)?_c('span',{staticClass:"prefix"},[_c('doe-icon',{attrs:{"icon":_vm.prefix,"size":_vm.iconSize,"colour":_vm.iconColour}})],1):_vm._e(),_c('span',{class:{ 'pl-1': _vm.hasSlot && _vm.prefix, 'pr-1': _vm.hasSlot && _vm.suffix }},[_vm._v("\n    "+_vm._s(_vm.buttonLabel)+"\n  ")]),(_vm.suffix)?_c('span',{staticClass:"suffix"},[_c('doe-icon',{attrs:{"icon":_vm.suffix,"size":_vm.iconSize}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }